import AgyleCalendar from "./agyleCalendar";
import AgyleCalendarDaily from "./agyleCalendarDaily";
import React, {useEffect, useState} from 'react';
import AgyleSelectField from "../ui/selector/agyleSelectField";
import {Paper} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import moment from "moment";
import AgyleDialog from '../modal/agyleDialog';
import AgyleButton from '../ui/buttons/agyleButton';
import useOpenState from '../../hooks/useOpenState';
import BedasSessionsManager from './calendarComponent/bedasSessionsManager';
import {hasPermission, Permissions} from '../../store/reducers/user';
import {useDispatch, useSelector} from 'react-redux';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import {
    currentMap,
    updateSingleBedasSessions,
} from '../../store/reducers/ward';
import config from '../../app/config';

const TYPES = [
    {id: "monthly", name: "Monthly"},
    {id: "daily", name: "Daily"},
];

const useStyles = makeStyles((theme) => ({
    paper: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.background.default,
        marginTop: 15,
        borderRadius: 10,
        padding: 10,
        width: "100%",
        position: 'relative'
    },
    switch: {
        width: 200,
        marginLeft: "auto",
    },
    selectedTimesWarning: {
        marginLeft: 20,
        marginTop: 14,
        height: 'fit-content',
        marginRight: 15,
        backgroundColor: theme.palette.background.default,
        minWidth: 300,
        padding: "10px 20px",
        borderRadius: 10,
        position: 'sticky',
        top: 0,
        right: 0
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 10,
        marginLeft: '-5px'
    }
}));

const AgyleSwitchCalendar = (props) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const hospital = useSelector(currentMap);

    const [type, setType] = useState("monthly");
    const [selectedDay, setSelectedDay] = useState(moment());
    const [selectedTimes, setSelectedTimes] = useState([]);
    const [selectedMode, setSelectedMode] = useState(null);

    const [isBlockModalOpen, openBlockModal, closeBlockModal] = useOpenState(false);
    const canEnterManageSessions = dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_BEDAS_CALENDAR));
    const canManageSingleSessions = dispatch(hasPermission(Permissions.AGYLE_CAN_MANUAL_MANAGE_BEDAS_CALENDAR));

    const componentLabel = config?.appointmentNotBedasLabel ? 'Appointment' : 'Follow Up';

    useEffect(() => {
        setType("monthly")
    }, [props.open]);

    const handleSelectDate = (day) => {
        setSelectedDay(day);
        setType("daily");
    };

    const handleChangeType = (val) => {
        if (val === "monthly") setSelectedDay(moment());
        setType(val);
    };

    const handleChangeSelectedTimes = (times, unlockSession) => {
        let timesArray = [];
        let objectExists = false;

        if (_.isArray(selectedTimes) && !_.isEmpty(selectedTimes)) {
            timesArray = [...selectedTimes];
        }

        if (!_.isEmpty(timesArray)) {
            _.forEach(timesArray, (time) => {
                if (times && (time?.from === times?.toISOString())) {
                    objectExists = true;
                }
            })
        }

        if (objectExists) {
            if (unlockSession) {
                const itemIndex = _.findIndex(timesArray, (time) => time?.from === times?.toISOString());
                timesArray[itemIndex].locked = false;
                setSelectedTimes(timesArray);
            } else {
                const itemIndex = _.findIndex(timesArray, (time) => time?.from === times?.toISOString());
                timesArray[itemIndex].locked = true;
                setSelectedTimes(timesArray);
            }
            return;
        }

        if (times) {
            const pushableObj = {
                from: times.toISOString(),
                to: times.add(30, "minutes").toISOString(),
                id: uuidv4(),
                locked: selectedMode === 'block',
            }

            timesArray.push(pushableObj);
            const sortedArr = _.sortBy(timesArray, (time) => {
                return time?.from;
            });

            setSelectedTimes(sortedArr);
        }
    }

    const deleteTemporaryLockedSession = (id) => {
        let index;
        if (id) {
            index = _.findIndex(selectedTimes, (ses) => ses?.id === id);
            let tmp = [...selectedTimes];
            tmp.splice(index, 1);
            setSelectedTimes(tmp);
        }
    }

    const handleChangeLockedReason = (session, value) => {
        const {id} = session;

        let validSession = _.find(selectedTimes, (ses) => ses?.id === id);
        const sessionIndex = _.findIndex(selectedTimes, (ses) => ses?.id === id);

        if (validSession) {
            validSession.lockedReason = value;
        }

        let newSelectedTimes = [...selectedTimes];
        newSelectedTimes[sessionIndex] = validSession;
        setSelectedTimes(newSelectedTimes);
    }

    const handelSelectField = (e) => {
        if (!!selectedMode) {
            handleChangeSelectedTimes(e, selectedMode === 'unblock');
        }
        if (props.handleSelect) props.handleSelect(e);
    };

    const handleChangeMode = (mode) => {
        if (selectedMode === mode) {
            setSelectedTimes([])
            return setSelectedMode(null);
        }
        setSelectedMode(mode);
    }

    const getHeader = () => {

        let header = `${componentLabel} Calendar`;
        if (selectedMode) {
            header += `. Warning: You are about to ${selectedMode === 'block' ? 'lock' : 'unlock'} the ${componentLabel} session for ${moment(selectedDay).format('DD/MM/YYYY')}.`;
        }
        return header;
    }

    const handleSaveSingleSessions = async () => {
        try {
            dispatch(updateSingleBedasSessions(hospital?.hospitalId, selectedTimes, null, hospital ))

            setSelectedMode(null);
            setSelectedTimes([]);

        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (!props.open) {
            setSelectedTimes([])
            setSelectedMode(null);
        }

        if (!selectedMode) {
            setSelectedTimes([])
        }
    }, [props.open, selectedMode])

    useEffect(() => {
        if (selectedTimes && !_.isEmpty(selectedTimes)) {
            const clone = _.cloneDeep(selectedTimes);
            if (selectedMode === 'unblock') {
                _.forEach(clone, (time) => {
                    time.locked = false;
                    time.lockedReason = undefined;
                })
            } else {
                _.forEach(clone, (time) => {
                    time.locked = true;
                })
            }

            setSelectedTimes(clone);
        }
    }, [selectedMode, selectedTimes.length])

    const buttons = () => {
        let buttonList = [];
        if (config?.bedasSessionManagementEnabled && !config?.bedas?.bedasOldCalendar) {
            if (canEnterManageSessions) {
                buttonList.push(
                  <AgyleButton
                    key="block"
                    onClick={() => {
                        openBlockModal();
                    }}
                    variant="contained"
                    color="primary"
                  >
                      {t(`Add ${componentLabel} Session`)}
                  </AgyleButton>
                )
            }

            if (type === 'daily' && canManageSingleSessions && !props?.dischargeForm) {
                    buttonList.push(
                        <AgyleButton
                            key="block"
                            onClick={() => {
                                handleChangeMode('block');
                            }}
                            variant="contained"
                        >
                            {t(`Lock ${componentLabel} Session`)}
                        </AgyleButton>,
                        <AgyleButton
                            key="block"
                            onClick={() => {
                                handleChangeMode('unblock');
                            }}
                            variant="contained"
                        >
                            {t(`Unlock ${componentLabel} Session`)}
                        </AgyleButton>
                    )
            }
        }

        return buttonList;
    }

    const renderSelectedTimes = (from, to) => {
        return (
            <div style={{display: 'flex', flexWrap: 'nowrap', alignItems: 'center'}}>
                <Typography variant="subtitle1">
                    From: <b>{moment(from).format("HH:mm")}</b>
                </Typography>
                <Typography variant="subtitle1" sx={{ml: 1}}>
                    To: <b>{moment(to).format("HH:mm")}</b>
                </Typography>
            </div>
        )
    }

    const renderCalendar = () => {
        switch (type) {
            case "daily":
                return (
                    <AgyleCalendarDaily
                        events={props.events}
                        selectedDay={selectedDay}
                        type={props.calendarType}
                        handleSelect={handelSelectField}
                        selectedMode={selectedMode}
                        selectedTimes={selectedTimes}
                        changeLockedReason={handleChangeLockedReason}
                        deleteTemporaryLockedSession={deleteTemporaryLockedSession}
                        selectTime={handelSelectField}
                        dischargeForm={props.dischargeForm}
                        hospital={hospital}
                    />
                );
            case "monthly":
            default:
                return (
                    <AgyleCalendar
                        events={props.events}
                        type={props.calendarType}
                        handleSelectDate={handleSelectDate}
                        dischargeForm={props.dischargeForm}
                    />
                );
        }
    };

    return (
      <div style={{position: 'relative'}}>
          <AgyleDialog
            title={t(getHeader())}
            open={props.open}
            onClose={props.onClose}
            disableSave
            closeButtonOnHeader
            fullWidth
            width="xl"
            buttons={buttons()}
            style={{overflowX: 'scroll'}}
          >
              <div style={{display: 'flex', flexDirection: 'row'}}>
                  <Paper className={classes.paper}>
                      <div className={classes.switch}>
                          <AgyleSelectField
                              onChange={handleChangeType}
                              value={type}
                              options={TYPES}
                              noBorder={false}
                              defaultClearValue="monthly"
                              label={t("Calendar Type")}
                              style={{width: "100%"}}
                          />
                      </div>
                      {renderCalendar()}
                  </Paper>
                  {selectedMode && (
                      <div className={classes.selectedTimesWarning}>
                         <Typography variant="subtitle1" fontWeight="bold">
                             {t(`Selected ${selectedMode === 'block' ? 'Lock' : 'Unlock'} Time`)}:
                         </Typography>
                            <Typography variant="subtitle1" sx={{pl: .5}}>
                                {selectedTimes && selectedTimes.length > 0 ?
                                    selectedTimes.map((time) => renderSelectedTimes(time?.from, time?.to))
                                    : t("No time selected")}
                            </Typography>

                          <div className={classes.actionButtons}>
                              <AgyleButton
                                key="block"
                                onClick={() => setSelectedTimes([])}
                              >
                                  {t("Clear")}
                              </AgyleButton>

                              <AgyleButton
                                  onClick={() => handleSaveSingleSessions()}
                                  variant={"contained"}
                                  color={"primary"}
                              >
                                  {t("Save")}
                              </AgyleButton>
                          </div>
                      </div>
                  )}
              </div>
          </AgyleDialog>

          <BedasSessionsManager
            open={props.openBlockModal || isBlockModalOpen}
            onClose={isBlockModalOpen ? closeBlockModal : props.closeBlockModal }
            sessionRef={props.sessionRef?.current ? props.sessionRef : null}
            hospital={hospital}
          />
      </div>
    );
};

export default AgyleSwitchCalendar;